<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-检查项管理-添加
    -->
    <el-dialog
    title="添加检查项管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加检查项管理</div>

      <el-form-item label="所属组织" prop="ma_company_id">
        <el-select v-model="form.ma_company_id" placeholder="请选择所属组织" style="width: 100%;" clearable filterable :loading="orgLoading">
          <el-option label="请选择所属组织" value=""></el-option>
          <el-option
            v-for="item in organizationList"
            :key="item.ma_company_id"
            :label="item.name"
            :value="item.ma_company_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="检查项管理名称" prop="name"><el-input v-model="form.name" placeholder="请输入检查项管理名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="有效期">
        <el-date-picker
          v-model="form.valid_time_start"
          type="datetime"
          placeholder="开始时间"
          style="width: 48%;"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-date-picker
          v-model="form.valid_time_end"
          type="datetime"
          placeholder="结束时间"
          style="width: 48%;"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="检查项设置">
        <el-tabs v-model="activeLevel1Id" @tab-click="handleLevel1Click" type="card">
          <el-tab-pane 
            v-for="item in level1List" 
            :key="item.inspection_id" 
            :label="item.name" 
            :name="item.inspection_id.toString()"
          ></el-tab-pane>
        </el-tabs>
        
        <div v-if="activeLevel1Id !== 'selected'" style="margin-top: 10px;">
          <div v-for="level2 in currentLevel2List" :key="level2.inspection_id" style="margin-bottom: 20px;">
            <el-checkbox 
              :indeterminate="isLevel2Indeterminate(level2.inspection_id)"
              v-model="level2Checked[level2.inspection_id]" 
              @change="handleLevel2Change(level2)"
              style="font-weight: bold; margin-bottom: 10px;"
            >
              {{ level2.name }}
            </el-checkbox>
            <el-checkbox-group v-model="selectedInspectionIds" @change="handleCheckboxChange">
              <el-checkbox 
                v-for="level3 in level2.children" 
                :key="level3.inspection_id" 
                :label="level3.inspection_id" 
                style="display: block; margin: 5px 0;"
              >
                {{ level3.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
     /*图片上传*/
     Upload: Upload
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        sort:50,
        bannar:[],
        ma_company_id: '',
        valid_time_start: '',
        valid_time_end: ''
      },
      organizationList: [],
      orgLoading: false,
      inspectionTree: [],
      level1List: [],
      selectedInspectionIds: [],
      selectedInspections: [],
      activeLevel1Id: null,
      level2Checked: {},
      treeProps: {
        children: 'children',
        label: 'name'
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入检查项管理名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  computed: {
    currentLevel2List() {
      if (!this.activeLevel1Id) {
        return [];
      }
      const level1Item = this.inspectionTree.find(item => item.inspection_id.toString() === this.activeLevel1Id);
      return level1Item && level1Item.children ? level1Item.children : [];
    }
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getOrganizationList();
    this.getInspectionList();
  },
  props: ["open_add"],
  methods: {
    async getOrganizationList() {
      this.orgLoading = true;
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        if (response.code === 1 && response.data && response.data.list) {
          this.organizationList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('获取组织列表失败:', error);
      } finally {
        this.orgLoading = false;
      }
    },

    async getInspectionList() {
      try {
        const response = await AfuncApi.call({
          model: 'inspection',
          action: 'index',
          p_id: 0
        });
        if (response.code === 1 && response.data && response.data.list) {
          const listData = response.data.list.data || [];
          this.inspectionTree = this.buildTreeData(listData);
          this.level1List = listData.map(item => ({
            inspection_id: item.inspection_id,
            name: item.name
          }));
          if (this.level1List.length > 0) {
            this.activeLevel1Id = this.level1List[0].inspection_id.toString();
          }
        }
      } catch (error) {
        console.error('获取检查项列表失败:', error);
      }
    },

    buildTreeData(listData) {
      return listData.map(item => {
        const newItem = { ...item };
        if (newItem.grandchildren && newItem.grandchildren.length > 0) {
          newItem.children = newItem.grandchildren.map(subItem => {
            const newSubItem = { ...subItem };
            if (newSubItem.children && newSubItem.children.length > 0) {
              newSubItem.children = newSubItem.children.map(thirdItem => ({ ...thirdItem }));
            }
            return newSubItem;
          });
        }
        return newItem;
      });
    },

    handleLevel1Click(tab) {
      this.activeLevel1Id = tab.name;
      this.$nextTick(() => {
        this.updateLevel2Checked();
      });
    },

    handleLevel2Change(level2) {
      const isChecked = this.level2Checked[level2.inspection_id];
      if (isChecked && level2.children && level2.children.length > 0) {
        const level3Ids = level2.children.map(item => item.inspection_id);
        const newSelectedIds = [...new Set([...this.selectedInspectionIds, ...level3Ids])];
        this.selectedInspectionIds = newSelectedIds;
      } else {
        const level3Ids = level2.children.map(item => item.inspection_id);
        this.selectedInspectionIds = this.selectedInspectionIds.filter(id => !level3Ids.includes(id));
      }
      this.selectedInspections = this.getAllInspectionsById(this.inspectionTree, this.selectedInspectionIds);
    },

    handleCheckboxChange(checkedIds) {
      this.selectedInspections = this.getAllInspectionsById(this.inspectionTree, checkedIds);
      this.updateLevel2Checked();
    },

    updateLevel2Checked() {
      this.currentLevel2List.forEach(level2 => {
        const level3Ids = level2.children ? level2.children.map(item => item.inspection_id) : [];
        const allChecked = level3Ids.length > 0 && level3Ids.every(id => this.selectedInspectionIds.includes(id));
        const someChecked = level3Ids.some(id => this.selectedInspectionIds.includes(id));
        this.$set(this.level2Checked, level2.inspection_id, allChecked);
      });
    },

    isLevel2Indeterminate(level2Id) {
      const level2 = this.currentLevel2List.find(item => item.inspection_id === level2Id);
      if (!level2 || !level2.children || level2.children.length === 0) {
        return false;
      }
      const level3Ids = level2.children.map(item => item.inspection_id);
      const allChecked = level3Ids.every(id => this.selectedInspectionIds.includes(id));
      const someChecked = level3Ids.some(id => this.selectedInspectionIds.includes(id));
      return someChecked && !allChecked;
    },

    getAllInspectionsById(tree, ids) {
      let result = [];
      const findNodes = (nodes) => {
        nodes.forEach(node => {
          if (ids.includes(node.inspection_id)) {
            result.push(node);
          }
          if (node.children && node.children.length > 0) {
            findNodes(node.children);
          }
        });
      };
      findNodes(tree);
      return result;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      if (this.selectedInspections.length === 0) {
        self.$message({
          message: '请选择检查项',
          type: 'error'
        });
        return;
      }
      form.inspection_ids = this.selectedInspections.map(item => item.inspection_id).join(',');
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AfuncApi.call({
            model: 'ma_check_item',
            action: 'add',
            ...form
          })
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_check_item/index/part/add.vue